// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#ritttzy-footer{height:25px;width:100%}#ritttzy-footer svg{display:block;padding:0;margin:auto;height:25px}#ritttzy_footer:after{content:\"\";display:table;clear:both}.ritttzy-footer-fixed{position:fixed;bottom:0;left:0}.ritttzy-footer-default>div{background-color:#d64644}.ritttzy-footer-default .ritttzy-footer-color{fill:#fff}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
